import { Body } from "./Body";
import { Footer } from "./Footer";

const SourceTemplateStep = {
  Body,
  Footer,
  title: 'Source template'
};

export { SourceTemplateStep };